module.exports = __webpack_public_path__ + "fonts/AttikaGX.05a070ab.ttf";